/**
 * Generates a compact 6-char base36 id for a tab handle.
 *
 * Scoped to a single extension instance — collision probability for
 * up to a few hundred tabs per instance is negligible (~36^6 ≈ 2.18B).
 * Not cryptographically secure (uses `Math.random`); tab ids are not
 * a security boundary.
 */
export const generateTabId = (): string => {
	let id = Math.random().toString(36).slice(2, 8);
	// Defensive pad: very rarely Math.random produces a trailing run of zeros
	// that get stripped by toString(36); top up to 6 chars.
	while (id.length < 6) {
		id += Math.random().toString(36).slice(2);
	}
	return id;
};
